module.exports = "<div class=\"promo-content\">\r\n        <h4>Sorry</h4>\r\n        <p><em>{{Model.CoreProduct}}</em> is not included <br/>in your JustisOne subscription.</p>\r\n        <p>Please speak to your account administrator <br />or a member of the Justis Team.</p>\r\n        <p>Email: <a id=\"helpdesk-link\" href=\"mailto:helpdesk@justis.com\">helpdesk@justis.com</a> &nbsp;&nbsp;&nbsp;Phone: +44 (0)20 7284 8080</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/restricted-promo-content.html
// module id = 445
// module chunks = 1